import React from 'react';
import { FaArrowRight, FaCheck, FaPlus } from 'react-icons/fa';
import OfferOptionTile from './OfferOptionTile';
import { RehashOffer, RehashOfferSelection } from '../RehashPossibleModal';
import './OfferOptionsRow.scss';

interface OfferOptionsRowProps {
  originalOffer: RehashOffer;
  rehashedOffer: RehashOffer;
  selectedOffer: string;
  setSelectedOffer: (offer: RehashOfferSelection) => void;
}

const OfferOptionsRow: React.FC<OfferOptionsRowProps> = ({
  originalOffer,
  rehashedOffer,
  selectedOffer,
  setSelectedOffer,
}) => {
  const originalIconElement = (
    <div className="option-extras__icon option-extras__icon_check">
      <FaCheck />
    </div>
  );
  const rehashedIconElement = (
    <div className="option-extras__icon option-extras__icon_plus">
      <FaPlus />
    </div>
  );

  return (
    <div className="offer-options-row">
      <OfferOptionTile
        offer={originalOffer}
        selected={selectedOffer === 'original'}
        onClick={() => setSelectedOffer('original')}
        title={'Original Upstart offer'}
        iconElement={originalIconElement}
      />

      <div className="offer-options-row__arrow-container">
        <FaArrowRight />
      </div>

      <OfferOptionTile
        offer={rehashedOffer}
        selected={selectedOffer === 'rehashed'}
        onClick={() => setSelectedOffer('rehashed')}
        title={'Updated Upstart offer'}
        iconElement={rehashedIconElement}
      />
    </div>
  );
};

export default OfferOptionsRow;
